import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { constant } from 'src/app/constant/constant';
import { BaseHttpService } from 'src/app/utility/BaseHttpService';

@Injectable({
  providedIn: 'root'
})

export class VendorService {

  constructor(private baseHttpService: BaseHttpService) { }

  getVendorsByNPINo(vendor: any) {
    return this.baseHttpService.post<any>(constant.getVendorsByNPINoUrl, vendor, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getVendorsWithContractByNPINo(vendor: any) {
    return this.baseHttpService.post<any>(constant.getVendorsWithContractByNPINoUrl, vendor, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getContractByVendorAndNPI(request: any) {
    return this.baseHttpService.post<any>(constant.getContractByVendorAndNPIUrl, request, constant.httpClientHeader.headers).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

}
